import React, { useContext } from 'react';
import { Footer, MenuBar } from '../../layout/welcome';
import { MembershipContext } from '../../context/membership/membership';
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "../../utils/query-parameter";
import { _retrieveData, _storeData } from "../../utils/local-storage";
import moment from "moment";
import useScrollBarPosition from "../../effect/Scroll";
import { useWindowSize } from "../../effect/WindowSize";
import { authGetRequest, getCourseItemAPI, getRequest } from "../../api/laravel/public/api";
import { HeaderText } from '../../components';
import { StudentCourse } from '../../layout/Dashboard';
import { settingContext } from '../../context/Setting/Setting';

const Index = () => {
    const size = useWindowSize();
    const router = useHistory();
    const param = useQuery();
    const { id } = useParams();
    // const { data } = getCourseItemAPI(course);
    const { membership } = useContext(MembershipContext);
    const [user, setUser] = React.useState({});
    // const { user } = useContext(AuthContext);
    const [data, setData] = React.useState({});
    const [isLoading, setLoading] = React.useState(false);
    const [isPageLoader, setPageLoader] = React.useState(false);
    const [tab, setTab] = React.useState(0);
    // const { page, loading } = React.useContext(settingContext);
    const { page } = React.useContext(settingContext);
    const [loading, setLoadingn] = React.useState(false);
    const [modal, setModal] = React.useState(false);
    const playerRef = React.useRef(null);
    const [session, setSession] = React.useState(0);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        checkUser();
    }, []);

    React.useEffect(() => {
        instructorDetail();
    }, []);

    // const initialApi = async () => {
    //     setLoadingn(true);
    //     const pageData = await _retrieveData("page_data");
    //     if (pageData) {
    //         setPage(pageData);
    //         setLoadingn(true);
    //     }
    //     const { data_r, message, isError, isLoading } = await getRequest(
    //         `/auth/api/page`
    //     );
    //     setPage(data_r);
    //     setLoadingn(false);
    //     await _storeData(data_r, "page_data");
    // };

    const checkUser = async () => {
        let storeUser = await _retrieveData('user');
        if (storeUser) {
            setUser(storeUser);
        }
        const { data_r, isLoading, isError } = await authGetRequest("/account/profile/");
        if (isError) {
            setUser({});
            // history.push("/auth/login");
        }
        else {
            await _storeData(data_r, 'user');
            setUser(data_r);
        }
    }

    const instructorDetail = async () => {
        const { data_r, isLoading, isError } = await authGetRequest("/course/instructor/detail/" + id);
        setData(data_r)
    }

    return (
        <div id="page-top" class="home">
            <div id="page-wrap">
                <MenuBar menuIndex="" setting={page?.setting} loader={isPageLoader} />
                <section className="sub-banner sub-banner-course">
                    <div className="awe-static bg-sub-banner-course" style={{ backgroundImage: 'url(../img/course_banner.jpeg)' }} />
                    <div className="awe-overlay" />
                    <div className="container">
                        <div className="sub-banner-content">
                            <h1 className="text-center text-white font-bold text-5xl">{data?.first_name} {data?.last_name}</h1>
                        </div>
                    </div>
                </section>
                <section className="course-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="sidebar-course-intro">
                                    <div className="breadcrumb">
                                        <Link to="/">Home</Link> /
                                        <Link to="/courses">Courses</Link> /
                                        {data?.first_name} {data?.last_name}
                                    </div>
                                    <div className="instructor-intro">
                                        <div className="inner">
                                            <div className="d-flex flex-row align-items-center justify-content-center ">
                                                <div className="image-bg-instructor text-center">
                                                    <img src={process.env.REACT_APP_LOCAL_FILE_PATH +
                                                        "profile/medium/" +
                                                        data?.image} alt="" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="tabs-page">
                                    <ul className="nav-tabs" role="tablist">
                                        <li className="active"><a href="#introduction" role="tab" data-toggle="tab">Instructor detail</a></li>
                                        <li><a href="#outline" role="tab" data-toggle="tab">Assigned Courses</a></li>
                                    </ul>
                                    <div className="tab-content">

                                        <div className="tab-pane fade in active" id="introduction">
                                            <div dangerouslySetInnerHTML={{
                                                __html: data?.description,
                                            }}>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="outline">
                                            <div className="container mt-4">
                                                {/* <HeaderText text={"Active Course"} /> */}
                                                <div className="row">
                                                    {data?.assign?.map((item, index) => {
                                                        if (index < 3)
                                                            return (
                                                                <StudentCourse
                                                                    item={item.course}
                                                                    list={6}
                                                                    link={item ? "/course/" + item?.course?.uuid : ""}
                                                                    progress={null}
                                                                    key={index}
                                                                />
                                                            )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer setting={page?.setting} />
            </div>
        </div>
    );
};

export default Index;